// extracted by mini-css-extract-plugin
export default {"wrap":"AdminPageSkeleton_wrap__6btoW","columns":"AdminPageSkeleton_columns__YcH2m","column":"AdminPageSkeleton_column__cfkJu"};